var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_c('div',[_vm._v(_vm._s(_vm.currentDate))]),_c('div',[_vm._v(_vm._s(_vm.organization))]),_c('div',[_vm._v(_vm._s(_vm.premeeting))]),_c('div',[_vm._v(_vm._s(_vm.adress))])])}
var staticRenderFns = []

export { render, staticRenderFns }